<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card
          class="full-width"
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <div slot="header">
            <strong>
              Edit Product
              {{ itemObj.Name ? `- ${itemObj.Name}` : "" }}
            </strong>
            <router-link
              to="/item"
              style="color: white; text-decoration: none; float: right"
            >
              <strong class="mr-1 btn btn-success">Back</strong>
            </router-link>
          </div>
          <div>
            <b-card>
              <b-row class="ml-5">
                <b-col sm="4" @click="() => showImagePicker('icon')">
                  <b-form-group
                    label="Icon"
                    label-for="Icon"
                    :label-cols="7"
                  ></b-form-group>
                  <single-image
                    height="210px"
                    width="180px"
                    v-if="iconImagedata"
                    :url="itemObj.product_summary.images.icon"
                    label="Browse for Icon"
                  ></single-image>
                </b-col>
                <b-col sm="4" @click="() => showImagePicker('smallImage')">
                  <b-form-group
                    label="Small Image"
                    label-for="SmallImage"
                    :label-cols="7"
                    :horizontal="true"
                  ></b-form-group>
                  <single-image
                    height="200px"
                    width="180px"
                    v-if="smallImagedata"
                    :url="itemObj.product_summary.images.smallImage"
                    label="Browse Small Image"
                  ></single-image>
                </b-col>
                <b-col sm="4" @click="() => showImagePicker('bigImage')">
                  <b-form-group
                    label="Big Image"
                    label-for="BigImage"
                    :label-cols="7"
                    :horizontal="true"
                  ></b-form-group>
                  <single-image
                    height="200px"
                    width="180px"
                    v-if="landingImagedata"
                    :url="itemObj.product_summary.images.bigImage"
                    label="Browse for Big Image"
                  ></single-image>
                </b-col>
              </b-row>
            </b-card>
            <b-modal
              v-model="showImageSelector"
              centered
              scrollable
              size="lg"
              style="width: 100px"
            >
              <div class="p-2">
                <b-row>
                  <div class="md-3">
                    <v-switch class="pa-2" color="blue" v-model="showLibrary"></v-switch>
                    <span class="mr-2 mb-1">Pick From Library</span>
                  </div>
                  <div class="md-3 ml-auto" v-if="!showLibrary">
                    <b-button @click="$refs.imageUploader.click()"
                      >Select and Upload New</b-button
                    >
                    <input
                      style="display: none"
                      ref="imageUploader"
                      type="file"
                      @change="uploadImageFromSelector"
                    />
                  </div>
                </b-row>
                <b-row
                  v-if="showLibrary"
                  style="max-height: 400px; overflow-x: auto; text-align: center"
                >
                  <b-col
                    v-for="(d, i) in imageLibraryList"
                    :key="i"
                    md="2"
                    @click="setImageFromLibrary(d.images)"
                  >
                    <img
                      :src="d.images[libraryImageSelector]"
                      style="object-fit: contain"
                      height="100px"
                      width="100%"
                    />
                    {{ d.title }}
                  </b-col>
                </b-row>
              </div>
            </b-modal>
          </div>
          <div v-for="(entry, idx) in attributesMap.entries()" :key="idx">
            <b-row>
              <b-col
                v-for="(item, index) in entry[1]"
                :key="index"
                :md="['Array'].includes(item.type) ? 12 : 6"
                :style="{
                  display:
                    item.type !== 'Array' ||
                    (item.type === 'Array' &&
                      valuesMap[item.name] &&
                      valuesMap[item.name][0])
                      ? 'block'
                      : 'none',
                }"
              >
                <field
                  v-if="
                    item.name !== 'days' &&
                    item.name !== 'Type' &&
                    item.name !== 'IsSellable'
                  "
                  :fieldType="item.type"
                  :fieldName="item.name"
                  :displayName="
                    item.attributeLabel && item.attributeLabel[tenantLang]
                      ? item.attributeLabel[tenantLang]
                      : item.name
                  "
                  :onChange="fieldChange"
                  :value="valuesMap[item.name]"
                  :id="item._id"
                  :isRequired="item.isRequired"
                  :subFields="item.attributeItems"
                  :level="0"
                  :meta="[{ name: item.name, type: item.type }]"
                  :active="activeIndex"
                  :index="index"
                  :setActive="setActive"
                  :UIConcern="item.UIConcern"
                  :arrayChange="arrayChange"
                  :valuesMap="valuesMap"
                  :visibility="item.visibility ? item.visibility.onUpdate : true"
                />
                <b-col v-if="item.name === 'IsSellable'">
                  <v-switch
                    color="indigo"
                    v-model="inputObj['IsSellable']"
                    :label="`IsSellable`"
                  ></v-switch>
                </b-col>
              </b-col>
            </b-row>
          </div>
          <div v-if="isAddresscapture">
            <b-row>
              <b-col>
                <Card>
                  <div class="wrap">
                    <b-form-group>
                      <p class="head">Location</p>
                      <GmapAutocomplete
                        @place_changed="placechange"
                        :placeholder="locationplaceholder"
                        class="mt-1 location-search"
                        :options="{
                          fields: ['geometry', 'formatted_address', 'address_components'],
                        }"
                        @focus="locationplaceholder = 'Enter New Location'"
                        @blur="locationplaceholder = itemObj.Address.Address"
                      ></GmapAutocomplete>
                    </b-form-group>
                  </div>
                </Card>
              </b-col>
            </b-row>
          </div>
          <a-divider />
          <div class="form-actions" v-if="!submitted">
            <button class="mr-1 btn btn-primary" variant="facebook" @click="handleSumit">
              <span>Update Item</span>
            </button>
            <router-link to="/item">
              <button class="mr-1 btn btn-danger" variant="html5">
                <span>Cancel</span>
              </button>
            </router-link>
          </div>
          <div class="form-action" v-else>
            <v-progress-circular :indeterminate="true" color="light-blue" />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
.flex-row {
  display: flex;
}
</style>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import cTable from "../base/Table.vue";
import Field from "@/components/Item/Field";
import Card from "../../components/Generics/Card.vue";
import Vue from "vue";
import SingleImage from "../../components/Common/Image.vue";
import VueUploadMultipleImage from "@/components/FormElements/VueUploadMultipleImage";
import locationMixins from "@/mixins/addressLocation";
import { BUCKET_BASEURL, GATEWAY_BASEURL } from "@/services/index";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "editItem",
  dark: {
    type: Boolean,
    default: false,
  },
  components: {
    cSwitch,
    cTable,
    Card,
    field: Field,
    SingleImage,
    VueUploadMultipleImage,
  },
  mixins: [locationMixins],
  data() {
    return {
      isAddresscapture: false,
      locationplaceholder: "",
      catalogObj: null,
      iconImagedata: null,
      smallImagedata: null,
      landingImagedata: null,
      libraryImageSelector: "",
      showImageSelector: false,
      showLibrary: false,
      alternateImages: [],
      itemObj: {},
      inputObj: {
        Name: "",
        description_summary: "",
        provider: null,
        catalogId: "",
        images: {
          icon: "",
          smallImage: "",
          bigImage: "",
          alternateImages: [],
        },
      },
      externalAttribute: [],
      attributesMap: new Map(),
      valuesMap: {},
      activeIndex: null,
      submitted: false,
    };
  },
  props: {
    context: {
      type: String,
    },
  },
  methods: {
    ...mapActions({
      getImageLibraryList: "catalog/listImageLibrary",
      createLibrary: "catalog/createImageLibrary",
    }),
    showImagePicker(selector) {
      this.libraryImageSelector = selector;
      this.showImageSelector = true;
    },
    uploadImageFromSelector(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const image = e.target.result;
        this.image = image;
        this.uploadImage(this.libraryImageSelector, image);
        this.$refs["imageUploader"].value = "";
      };
      reader.readAsDataURL(file);
    },
    async fetchImages() {
      this.iconImagedata = await this.getImageUrl(
        this.itemObj.product_summary.images.icon
      );
      this.smallImagedata = await this.getImageUrl(
        this.itemObj.product_summary.images.smallImage
      );
      this.landingImagedata = await this.getImageUrl(
        this.itemObj.product_summary.images.bigImage
      );
    },
    async getImageKeyfromURL(imageURL) {
      const key = await imageURL.replace(BUCKET_BASEURL, "");
      return key;
    },
    // resize image storage service
    async getImageUrl(imageURL) {
      const imageKey = await this.getImageKeyfromURL(imageURL);
      return `${GATEWAY_BASEURL}/resize/index.php?width=300&height=250&quality=100&name=${imageKey}`;
    },
    changeIcon(e) {
      this.uploadImage("icon", e);
    },
    changeSmallImage(e) {
      this.uploadImage("smallimage", e);
    },
    changeBigImage(e) {
      this.uploadImage("largeimage", e);
    },
    setAlternateImages(images) {
      this.inputObj.images.alternateImages = images.map((i) => ({ image: i }));
    },
    setImageFromLibrary(images) {
      console.log(images, this.libraryImageSelector);
      this.itemObj.product_summary.images[this.libraryImageSelector] =
        images[this.libraryImageSelector];
      this.libraryImageSelector = "";
      this.showImageSelector = false;
    },

    // upload images to the S3 bucket
    async uploadImage(type, image) {
      this.showImageSelector = false;
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: ["seller", "items"],
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          if (res) {
            this.clearCustomToast();
            if (type === "icon") {
              this.itemObj.product_summary.images.icon = res.data.fileUrl;
            } else if (type === "smallImage") {
              this.itemObj.product_summary.images.smallImage = res.data.fileUrl;
            } else {
              this.itemObj.product_summary.images.bigImage = res.data.fileUrl;
            }
          }
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    async getCatalog() {
      await this.$store
        .dispatch("catalog/fetchCatalogById", this.inputObj.catalogId)
        .then((result) => {
          if (result.status !== 0) {
            this.catalogObj = result.response;

            let typeSet = new Set(["String", "Number", "Object", "Array", "Boolean"]);
            const default_str_attributes = [
              {
                type: "String",
                name: "Title",
                _id: "9",
              },
            ];
            let attributesMap = new Map([
              ["String", default_str_attributes],
              ["Number", []],
              ["Object", []],
              ["Array", []],
              ["Boolean", []],
            ]);
            let valuesMap = {};
            valuesMap.Title = "";
            result.response.externalAttributes.forEach((item) => {
              if (item.attributeRef) {
                let type = item.attributeRef.attributeValueType;
                let name = item.attributeRef.attributeName;
                if (typeSet.has(type)) {
                  let attObj = {
                    ...item,
                    ...item.attributeRef,
                    type,
                    name,
                  };
                  attributesMap.set(type, attributesMap.get(type).concat([attObj]));
                  if (["String", "Number"].includes(type)) valuesMap[name] = "";
                  else if (type === "Boolean") {
                    valuesMap[name] = value.active;
                    this.inputObj[name] = false;
                  } else if (type === "Object") valuesMap[name] = {};
                  else if (type === "Array") {
                    if (["Checkbox"].includes(attObj.UIConcern))
                      valuesMap[name] = attObj.attributeItems;
                    else if (attObj.UIConcern === "Radio") valuesMap[name] = null;
                    else if (attObj.UIConcern === "Select") valuesMap[name] = [];
                    else if (attObj.UIConcern === "Object") {
                      let temp = {};
                      for (
                        let i = 0;
                        i < Object.keys(attObj.attributeItems).length;
                        i++
                      ) {
                        let key = attObj.attributeItems[i].attributeName;
                        temp[key] = "";
                      }
                      valuesMap[name] = [temp];
                    }
                  }
                }
              }
            });
            this.attributesMap = attributesMap;
            this.valuesMap = valuesMap;
          }
        });
    },
    fieldChange(data) {
      if (data.meta[0].name === "Name") {
        this.inputObj.Name = data.value;
        this.inputObj.description_summary = data.value;
      } else {
        if (data.meta[0].type === "String" && data.meta[0].name !== "Title") {
          this.inputObj[data.meta[0].name] = data.value;
        } else if (data.meta[0].type === "Number") {
          this.inputObj[data.meta[0].name] =
            typeof data.value === "string" ? Number(data.value) : data.value;
        } else if (data.meta[0].type === "Boolean") {
          this.inputObj[data.meta[0].name] = data.value;
        } else if (data.meta[0].type === "Object") {
          this.inputObj[data.meta[0].name] = data.value;
        }
      }

      // typeof this.inputObj["Price"] !== undefined && typeof this.inputObj["Discount"] !== undefined && typeof this.inputObj["Discount(%)"] !== undefined
      if (
        this.inputObj["Deal Price"] &&
        typeof this.inputObj["Deal Price"] !== "undefined" &&
        this.inputObj["Price"] &&
        typeof this.inputObj["Price"] !== "undefined" &&
        ((this.inputObj["Discount"] &&
          typeof this.inputObj["Discount"] !== "undefined") ||
          (this.inputObj["Discount(%)"] &&
            typeof this.inputObj["Discount(%)"] !== "undefined")) &&
        (data.meta[0].type === "String" || data.meta[0].type === "Number")
      ) {
        if (data.meta[0].name === "Price") {
          const discountAmount = this.inputObj["Discount(%)"]
            ? this.inputObj["Price"] * (this.inputObj["Discount(%)"] / 100)
            : this.inputObj["Discount"];
          if (discountAmount) {
            this.inputObj["Deal Price"] = (data.value - discountAmount).toString();
            this.inputObj["Discount"] = discountAmount;
            this.setUiUpdate();
          }
        } else if (data.meta[0].name === "Discount(%)") {
          const discountAmount =
            this.inputObj["Price"] * (this.inputObj["Discount(%)"] / 100);
          const discountedAmount = this.inputObj["Price"] - discountAmount;
          if (discountedAmount != this.inputObj["Deal Price"]) {
            this.inputObj["Deal Price"] = discountedAmount.toString();
            this.inputObj["Discount"] = discountAmount;
            this.setUiUpdate();
          }
        } else if (data.meta[0].name === "Discount") {
          const discountAmount = this.inputObj["Price"] - this.inputObj["Discount"];
          if (discountAmount != this.inputObj["Deal Price"]) {
            this.inputObj["Deal Price"] = discountAmount.toString();
            this.inputObj["Discount(%)"] = (
              (this.inputObj["Discount"] / this.inputObj["Price"]) *
              100
            ).toString();
            this.setUiUpdate();
          }
        }
      }
    },
    setUiUpdate() {
      this.valuesMap["Deal Price"] = this.inputObj["Deal Price"];
      this.valuesMap["Discount(%)"] = this.inputObj["Discount(%)"];
      this.valuesMap["Discount"] = this.inputObj["Discount"];
    },
    async handleSumit() {
      let payload = {
        ...this.valuesMap,
        ...this.inputObj,
      };
      delete payload.tags;

      // Casting select fields
      Object.keys(this.valuesMap).forEach((key) => {
        let tempItem = this.valuesMap[key];
        if (
          Array.isArray(tempItem) &&
          tempItem.length > 0 &&
          tempItem[0] &&
          tempItem[0].value
        ) {
          payload[key] = tempItem.map((v) => v.value);
        }
      });
      // casting descipriton summary
      if (this.inputObj.hasOwnProperty("IsSellable")) {
        this.inputObj.IsSellable
          ? (payload.IsSellable = "TRUE")
          : (payload.IsSellable = "FALSE");
      }
      payload.description_summary = payload.Name;
      payload.catalogId = this.itemObj.catalogId;
      payload.provider = this.itemObj.provider;
      delete payload.product_summary;
      delete payload.updatedAt;
      delete payload.createdAt;
      delete payload._id;
      delete payload.Title;
      delete payload.attributeItems;
      delete payload.string_attributes;
      delete payload.integer_attributes;
      delete payload.itemIndex;
      payload.isDeleted = false;
      if (payload["isOffline"]) {
        payload.isOffline = this.itemObj.isOffline;
      } else {
        payload.isOffline = false;
      }
      if (payload["Name"] === "") {
        payload["Name"] = this.itemObj.Name;
        payload["description_summary"] = payload["Name"];
      }
      payload.images.icon = this.itemObj.product_summary.images.icon;
      payload.images.smallImage = this.itemObj.product_summary.images.smallImage;
      payload.images.bigImage = this.itemObj.product_summary.images.bigImage;

      if (this.addressObj.data && this.isAddresscapture) {
        let fields = Object.keys(this.addressObj.data);
        fields.map((f) => {
          if (f !== "zip") {
            payload[f] = this.addressObj.data[f];
          }
        });
        payload.Lng = this.addressObj.Lng;
        payload.Lat = this.addressObj.Lat;
        payload.Address = {
          Lng: payload.Lng,
          Lat: payload.Lat,
          City: payload.City,
          State: payload.State,
          Country: payload.Country,
          Address: this.addressObj.address,
        };
        payload.Area = this.addressObj.address;
      } else if (this.isAddresscapture) {
        payload.City = this.itemObj.Address.City;
        payload.Country = this.itemObj.Address.Country;
        payload.State = this.itemObj.Address.State;
        payload.Lat = this.itemObj.Address.Lat;
        payload.Lng = this.itemObj.Address.Lng;
        payload.Address = {
          Lng: payload.Lng,
          Lat: payload.Lat,
          City: payload.City,
          State: payload.State,
          Country: payload.Country,
          Address: this.itemObj.Address.Address,
        };
        payload.Area = payload.Address.Address;
      }
      // delete payload["Availability"];

      const payloaddata = payload;
      let dataObj = { id: this.$route.params.id, object: payloaddata };
      this.$store
        .dispatch("item/updateItemById", dataObj)
        .then((result) => {
          this.$swal({
            title: "Success",
            text: "Item has been updated successfully",
            type: "success",
          });
          this.$router.push({ path: "/item" });
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: "Item has not been updated!!",
            type: "error",
          });
        });
    },
    setActive(i) {
      this.activeIndex = this.activeIndex == i ? -1 : i;
    },
    arrayChange(data) {
      let { index, type, e, fieldName } = data;
      let { meta, value, action, arrObj } = data;
      let updateDoc = { ...this.valuesMap };
      let temp = this.valuesMap;
      let parent = temp;
      let path = "";
      for (let i = 0; i < meta.length; i++) {
        let item = meta[i],
          { type, name } = item;
        if (["Object", "String", "Number", "Array", "Boolean"].includes(type)) {
          parent = temp;
          path = item.name;
          temp = temp[item.name];
        }
      }
      let name = index;
      switch (type) {
        case "check": {
          this.$set(temp[index], "checked", e.target.checked);
          break;
        }
        case "select": {
          this.$set(parent, fieldName, e);
          break;
        }
        case "radio": {
          this.$set(parent, fieldName, e);
        }
      }
      if (arrObj === true) {
        switch (action) {
          case "change": {
            this.$set(
              parent,
              path,
              temp.map((item, idx) =>
                idx === index
                  ? {
                      ...item,
                      [fieldName]: e,
                    }
                  : item
              )
            );
            break;
          }
          case "add": {
            let tObj = {};
            let keys = Object.keys(temp[0]);
            for (let i = 0; i < keys.length; i++) {
              tObj[keys[i]] = "";
            }
            this.$set(parent, path, temp.concat([tObj]));
          }
          case "remove": {
            temp.splice(index, 1);
          }
        }
      }
    },
  },
  mounted: async function () {
    this.loading = true;
    if (true) {
      await this.$store.dispatch("item/fetchItemById", this.$route.params.id);
      let data = this.$store.getters["item/GetCurrentItemObject"];
      let result = data.response[0];
      this.itemObj = result;
      console.log(this.itemObj);
      if (this.itemObj.hasOwnProperty("IsSellable")) {
        this.itemObj.IsSellable === "TRUE"
          ? (this.inputObj["IsSellable"] = true)
          : (this.inputObj["IsSellable"] = false);
      }
      this.fetchImages();
      let keys = Object.keys(result);
      let typeSet = new Set(["String", "Number", "Object", "Array", "Boolean"]);
      let attributesMap = new Map([
        ["String", []],
        ["Number", []],
        ["Object", []],
        ["Array", []],
        ["Boolean", []],
      ]);
      let valuesMap = result;
      result.attributeItems.forEach((item) => {
        if (
          item &&
          item.attributeName !== "Address" &&
          item.attributeName !== "State" &&
          item.attributeName !== "Country" &&
          item.attributeName !== "City" &&
          item.attributeName !== "Area" &&
          item.attributeName !== "Lat" &&
          item.attributeName !== "Lng"
        ) {
          let type = item.attributeValueType,
            name = item.attributeName;

          // check key value is allowed type
          if (typeSet.has(type)) {
            let attObj = {
              ...item,
              type,
              name,
            };
            attributesMap.set(type, attributesMap.get(type).concat([attObj]));
            if (type == "Array") {
              if (attObj.UIConcern === "Select") {
                let options = new Map(
                  attObj.attributeItems.map((a) => [
                    a._id,
                    {
                      label: a.attributeName,
                      value: a._id,
                    },
                  ])
                );

                valuesMap[name] = valuesMap[name].map((o) => options.get(o));
              }
              if (attObj.UIConcern === "Object") {
                valuesMap[name] = valuesMap[name];
              } else if (type === "Boolean") {
                valuesMap[name] = valueItem.isActive;
                this.inputObj[name] = false;
              }
              if (attObj.UIConcern === "Checkbox") {
                valuesMap[name] = valuesMap[name];
              }
            }
            if (["Number", "String"].includes(type)) {
              const addresses = {
                Number: "integer_attributes",
                String: "string_attributes",
              };
              const attributes = result[addresses[type]];
              const valueItem = attributes.find((pair) => pair.attribute_name == name);
              if (valueItem) {
                valuesMap[name] = valueItem.attribute_value;
              }
            }
          }
        } else if (item.attributeName === "Address") {
          this.isAddresscapture = true;
          this.locationplaceholder = this.itemObj.Address.Address;
        }
      });
      this.attributesMap = attributesMap;
      this.valuesMap = valuesMap;
    }
    this.getImageLibraryList(this.itemObj.catalogId);
  },
  computed: {
    ...mapGetters({
      tenantLang: "tenant/GetTenantLanguage",
      imageLibraryList: "catalog/GetImageLibraryList",
    }),
    addressObj() {
      return this.$store.getters["item/GetCurrentCatalogLocation"];
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.card-wrap {
  border: none !important;
  box-shadow: 0px 0px 10px 1px rgb(235, 235, 235) !important;
  border-radius: 1px !important;
}
.wrap {
  margin: 10px;
}
.head {
  font-size: 1.2em;
  font-weight: 900;
}
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: 'Lato';
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}
.border-blue {
  border: 4px solid lightskyblue;
}
</style>
